package com.fireavert.properties.shared.client

import com.fireavert.common.Try
import com.fireavert.devices.data_models.data_model.DeviceType
import com.fireavert.gateways.gateway_property_page.data_models.requests.PropertyGatewayChangeRequest
import com.fireavert.gateways.shared.data_models.GatewayModel
import com.fireavert.management_companies.data_models.ManagementCompany
import com.fireavert.properties.add_new_property.data_models.requests.CreatePropertyRequest
import com.fireavert.properties.archive_property.data_models.requests.ArchivePropertyRequest
import com.fireavert.properties.fire_claim_data.data_models.requests.PropertyFireClaimRequest
import com.fireavert.properties.shared.data_models.FireClaimData
import com.fireavert.properties.shared.data_models.Property
import com.fireavert.properties.shared.data_models.PropertyAdminModel
import com.fireavert.properties.shared.data_models.requests.PropertyModeChangeRequest
import com.fireavert.properties.shared.data_models.responses.PropertyResponse
import com.fireavert.reports_page.shared.data_models.EventTypes

interface ClientPropertyRepository {
    suspend fun createProperty(request: CreatePropertyRequest): Try<Property>
    suspend fun getProperties(idList: List<Int> = emptyList()): Try<List<Property>>
    suspend fun getPropertiesNameAndIdMap(idList: List<Int> = emptyList()): Try<Map<String, Int>>
    suspend fun getPropertiesWithManagementCompany(idList: List<Int> = emptyList()): Try<Map<String, List<PropertyResponse>>>
    fun getPropertyByIdSync(id: Int): Try<Property>
    suspend fun getPropertyByIdAsync(id: Int): Try<Property>
    suspend fun modifyProperty(
       property: Property
    ): Try<Property>
    suspend fun deleteProperty(propertyId: Int): Try<Boolean>
    suspend fun getPropertyAdmins(propertyId: Int): Try<List<PropertyAdminModel>>
    suspend fun deletePropertyAdmin(propertyId: Int, propertyAdminUserId: Int): Try<Boolean>
    suspend fun createPropertyAdmin(propertyId: Int, propertyAdminModel: PropertyAdminModel): Try<Boolean>
    suspend fun modifyPropertyAdmin(propertyId: Int, propertyAdminModel: PropertyAdminModel): Try<Boolean>
    suspend fun getUnlinkedPropertyAdmins(propertyId: Int): Try<List<PropertyAdminModel>>
    suspend fun linkPropertyAdmin(propertyId: Int, propertyAdminId: Int): Try<Boolean>
    suspend fun resendPropertyAdminInvite(id: String): Try<Boolean>
    suspend fun getFireClaims(propertyId: Int): Try<List<FireClaimData>>
    suspend fun modifyFireClaims(fireClaimRequest: PropertyFireClaimRequest): Try<Boolean>
    suspend fun getPropertyGateways(propertyId: Int): Try<List<GatewayModel>>
    suspend fun modifyGatewayChanges(propertyGatewayChangeRequest: PropertyGatewayChangeRequest): Try<Boolean>
    suspend fun updatePropertyMode(request: PropertyModeChangeRequest): Try<Boolean>
    suspend fun archiveProperty(request: ArchivePropertyRequest): Try<Boolean>
    suspend fun getSensorTypesForProperty(propertyId: Int?): Try<List<EventTypes>>
    suspend fun updatePropertySensorTypes(propertyId: Int, deviceTypes: Set<DeviceType>): Try<Boolean>
    suspend fun getManagementCompanies(): Try<List<ManagementCompany>>
}